import TourWishlist from '@app/_common/tour-wishlist/wishlist';

export default function SerpToursWishlist(
  SELECTOR_JS_TOUR_CARD,
  CLASS_WISHLIST_BUTTON,
  CLASS_WISHLIST_ACTIVE_CLASS,
  CLASS_TOUR_SAVED,
  CLASS_JS_TOUR_SAVED,
) {
  let CLASS_JS_SERP_TOUR_SAVED = CLASS_JS_TOUR_SAVED;
  const SELECTOR_SERP_TITLE = '.js-ao-serp-hero__title';

  this.initiate = () => {
    if (!CLASS_JS_SERP_TOUR_SAVED) CLASS_JS_SERP_TOUR_SAVED = CLASS_TOUR_SAVED;

    const mainTitle = $(SELECTOR_SERP_TITLE).length ? $(SELECTOR_SERP_TITLE).text().trim() : 'No Serp Name';
    TourWishlist({
      containerSelector: '.list',
      tooltipSelector: '.js-wishlist-icon__tooltip',
      heartSelector: `${SELECTOR_JS_TOUR_CARD} .${CLASS_WISHLIST_BUTTON}`,
      heartActiveClass: CLASS_WISHLIST_ACTIVE_CLASS,
      googleEventData: {
        category: 'SERP',
        label: mainTitle,
      },
      getId: ($element) => $element.closest(SELECTOR_JS_TOUR_CARD).data('id'),
      getIndex: ($element) => $element.closest(SELECTOR_JS_TOUR_CARD).index() + 1,
      getTitle: ($element) => $element.closest(SELECTOR_JS_TOUR_CARD).find('.js-ao-serp-tour__name').text()?.trim(),
    });
  };
}
